import axios from 'axios';
import { API_SERVER_HOST, API_SERVER_HOST_COMMY } from '../../Config';

// const host = `${API_SERVER_HOST}/api/commy`;

const host = `${API_SERVER_HOST_COMMY}/api/community`;

export const CommunityRegisterByPost = async (commnunityParam) => {
  const response = await axios.post(`${host}/register`, commnunityParam);

  return response.data;
};

export const CommunityGetListByPost = async () => {
  const response = await axios.post(`${host}/getList`);
  return response;
};

export const CommunityDeleteByPost = async (communityId) => {
  const response = await axios.delete(`${host}/delete/${communityId}`);
  return response;
};

export const CommunityGetTypeByPost = async (communityId) => {
  const response = await axios.get(`${host}/getType/${communityId}`);
  return response;
};

export const CommunityPostRegisterByPost = async (commnunityPostParam) => {
  const response = await axios.post(`${host}/postRegister`, commnunityPostParam);
  return response;
};

export const CommunityPostDeleteByPost = async (selectedPosts) => {
  const response = await axios.put(`${host}/postsDelete`, selectedPosts);
  return response;
};

export const CommunityPostListByPost = async (commnunityPostParam) => {
  const response = await axios.post(`${host}/getPostList`, commnunityPostParam);
  return response;
};

export const CommunityPostDetailsByPost = async (postId) => {
  const response = await axios.post(`${host}/getPostDetails/${postId}`);
  return response;
};

export const CommunityPostLikeByPost = async (postParam) => {
  const response = await axios.post(`${host}/like`, postParam);
  return response;
};

export const CommunityPostIncrementViewCountByPost = async (postId) => {
  const response = await axios.put(`${host}/incrementView/${postId}`);
  return response;
};

export const CommunityCommentRegisterByPost = async (commentParam) => {
  const response = await axios.post(`${host}/commentRegister`, commentParam);
  return response;
};

export const CommunityCommentListByPost = async (commentParam) => {
  const response = await axios.post(`${host}/getCommentList`, commentParam);
  return response;
};

export const CommunityCommentLikeByPost = async (commentParam) => {
  const response = await axios.post(`${host}/commentLike`, commentParam);
  return response;
};

export const CommunityCommentDeleteByPost = async (commentId) => {
  const response = await axios.put(`${host}/commentDelete/${commentId}`);
  return response;
};

export const CommunityPostReportByPost = async (reportParam) => {
  const response = await axios.post(`${host}/report`, reportParam);
  return response;
};

export const S3DownloadTargetFileByPost = async (fileUrl) => {
  const response = await axios.post(`${host}/s3DownloadTargetFile`, fileUrl, {
    responseType: 'arraybuffer',
  });
  return response;
};
